<template>
  <div>
    <div class="marquee">
      <span v-for="i in 5" :key="i"
        >{{ `${serviceName} MOBILE TICKET ${nowTime}` }}
      </span>
    </div>
  </div>
</template>

<script>
import { ref, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import dayjs from "dayjs";
export default {
  name: "TicketMarquee",
  setup() {
    const store = useStore();
    const serviceName = store.getters["common/serviceName"];
    const nowTime = ref("");
    const getNowTime = () => {
      nowTime.value = dayjs().format("A h:mm:ss");
    };
    const interval = setInterval(getNowTime, 1000);
    onBeforeUnmount(() => {
      clearInterval(interval);
    });

    return { serviceName, nowTime };
  },
};
</script>
